import { combineReducers } from 'redux';
import { Book, ReduxAction, ReduxState } from '../types';

const displayedStatus = (state: string = 'reading', action: ReduxAction) => {
    return action.type === 'SET_DISPLAYED_STATUS' ? action.payload : state;
};

const isFetching = (state: boolean = false, action: ReduxAction) => {
    return action.type === 'TOGGLE_IS_FETCHING' ? action.payload : state;
};

const dataIsLoaded = (state: boolean = false, action: ReduxAction) => {
    return action.type === 'SET_DATA_IS_LOADED' ? true : state;
};

const error = (state: string | null = null, action: ReduxAction) => {
    return action.type === 'SET_ERROR' ? action.payload : state;
};


const editBook = (books: Book[], updatedBook: Book) => {
    const updatedBooks = [...books];
    const index = updatedBooks.findIndex((b) => b._links.self.href === updatedBook._links.self.href);
    updatedBooks[index] = updatedBook;
    return updatedBooks;
};

const books = (state: Book[] = [], action: ReduxAction) => {
    switch (action.type) {
        case 'GET_BOOKS':
            return action.payload;
        case 'ADD_BOOK':
            return [...state, action.payload];
        case 'EDIT_BOOK':
            return editBook(state, action.payload);
        case 'DELETE_BOOK':
            return state.filter((b) => b._links.self.href !== action.payload);
        default:
            return state;
    }
};


const rootReducer = combineReducers({
    displayedStatus,
    isFetching,
    dataIsLoaded,
    error,
    books,
});

const initialState: ReduxState = {
    displayedStatus: 'reading',
    isFetching: false,
    dataIsLoaded: false,
    error: null,
    books: [
        {
            "title": "Harry Potter and the Sorcerer's Stone",
            "authors": [
                "J.K. Rowling"
            ],
            "coverImage": null,
            "status": "completed",
            "_links": {
                "self": {
                    "href": "http://localhost:8080/api/books/60b5307b627e6459fccb7742"
                },
                "book": {
                    "href": "http://localhost:8080/api/books/60b5307b627e6459fccb7742"
                }
            }
        },
        {
            "title": "Harry Potter and the Chamher of Secrets",
            "authors": [
                "J.K. Rowling"
            ],
            "coverImage": null,
            "status": "completed",
            "_links": {
                "self": {
                    "href": "http://localhost:8080/api/books/60b534500ec47c77f6c4bf37"
                },
                "book": {
                    "href": "http://localhost:8080/api/books/60b534500ec47c77f6c4bf37"
                }
            }
        },
        {
            "title": "Harry Potter and the Prisoner of Azkaban",
            "authors": [
                "J.K. Rowling"
            ],
            "coverImage": "http://covers.openlibrary.org/b/olid/OL26234270M-S.jpg",
            "status": "reading",
            "_links": {
                "self": {
                    "href": "http://localhost:8080/api/books/60b6685a995a371b7a0564f4"
                },
                "book": {
                    "href": "http://localhost:8080/api/books/60b6685a995a371b7a0564f4"
                }
            }
        },
        {
            "title": "Harry Potter and the Chamber of Secrets",
            "authors": [
                "J.K. Rowling"
            ],
            "coverImage": null,
            "status": "backlog",
            "_links": {
                "self": {
                    "href": "http://localhost:8080/api/books/60b5330a7e4e7e44b22389f7"
                },
                "book": {
                    "href": "http://localhost:8080/api/books/60b5330a7e4e7e44b22389f7"
                }
            }
        },
        {
            "title": "Harry Potter and the Prisoner of Azkaban",
            "authors": [
                "J.K. Rowling"
            ],
            "coverImage": "http://covers.openlibrary.org/b/olid/OL26234270M-S.jpg",
            "status": "reading",
            "_links": {
                "self": {
                    "href": "http://localhost:8080/api/books/60b66864995a371b7a0564f5"
                },
                "book": {
                    "href": "http://localhost:8080/api/books/60b66864995a371b7a0564f5"
                }
            }
        }
    ],
};

export { rootReducer, initialState };